import React, { useState } from 'react'
import { connect } from 'react-redux'

import { hideDialog } from '~/actions/ui'
import {
  updatePersonalRoomName,
  updatePersonalRoomPassword,
  deletePersonalRoomPassword
} from '~/actions/room-settings'
import { copyPersonalRoomInfo } from '~/actions/room'
import {
  EDIT_PERSONAL_ROOM_SCREENS
} from '~/core/constants'
import MainScreen from './main'
import EditSuccessScreen from './edit-success'
import ConfirmUpdatePasswordScreen from './confirm-update-password'
import CopyNewInfoScreen from './copy-new-info'
import { isValidRoomPassword, isValidPersonalRoomName } from '~/core/utils'
import { getPersonalRoomName, getPersonalRoomPassword, getPersonalRoomUrl } from '~/selectors/room'

const PersonalRoomDialogs = ({
  personalRoom,
  password,
  url,
  ...rest
}) => {
  const [editedRoomName, setEditedRoomName] = useState(personalRoom)
  const [editedPassword, setEditedPassword] = useState(password)
  const [currentScreen, setCurrentScreen] = useState(EDIT_PERSONAL_ROOM_SCREENS.MAIN)

  const handleNameTextChange = event => {
    setEditedRoomName(event.target.value)
  }

  const handlePasswordTextChange = event => {
    setEditedPassword(event.target.value)
  }

  const updateNameAndPassword = () => {
    rest.updatePersonalRoomName(editedRoomName)
      .then(() => editedPassword ? rest.updatePersonalRoomPassword(editedPassword) : rest.deletePersonalRoomPassword())
      .then(() => {
        setCurrentScreen(EDIT_PERSONAL_ROOM_SCREENS.EDIT_SUCCESS)
      })
      .catch(() => {
        setCurrentScreen(null)
      })
  }

  const updateName = () => {
    rest.updatePersonalRoomName(editedRoomName)
      .then(() => {
        setCurrentScreen(EDIT_PERSONAL_ROOM_SCREENS.EDIT_SUCCESS)
      })
      .catch(() => {
        setCurrentScreen(null)
      })
  }

  const goToPasswordUpdateConfirmation = () => {
    setCurrentScreen(EDIT_PERSONAL_ROOM_SCREENS.CONFIRM_UPDATE_PASSWORD)
  }

  const onSave = () => {
    const iRoomNameEdited = editedRoomName !== personalRoom
    const isPasswordEdited = editedPassword !== password
    if (iRoomNameEdited) {
      if (isPasswordEdited) {
        updateNameAndPassword()
      } else {
        updateName()
      }
    } else if (editedPassword) {
      goToPasswordUpdateConfirmation()
    } else {
      deletePassword()
    }
  }

  const deletePassword = () => {
    rest.deletePersonalRoomPassword()
      .then(() => {
        setCurrentScreen(EDIT_PERSONAL_ROOM_SCREENS.EDIT_SUCCESS)
      })
      .catch(() => {
        setCurrentScreen(null)
      })
  }

  const updatePassword = () => {
    rest.updatePersonalRoomPassword(editedPassword)
      .then(() => {
        setCurrentScreen(EDIT_PERSONAL_ROOM_SCREENS.COPY_NEW_INFO)
      })
      .catch(() => {
        setCurrentScreen(null)
      })
  }

  const copy = () => {
    rest.copyPersonalRoomInfo()
    hideDialog()
  }

  const passwordHasErrors = !isValidRoomPassword(editedPassword)
  const roomNameHasErrors = !isValidPersonalRoomName(editedRoomName)

  switch (currentScreen) {
    case EDIT_PERSONAL_ROOM_SCREENS.MAIN:
      return (
        <MainScreen
          editedRoomName={editedRoomName}
          editedPassword={editedPassword}
          onRoomNameChange={handleNameTextChange}
          onPasswordChange={handlePasswordTextChange}
          onSave={onSave}
          password={password}
          personalRoom={personalRoom}
          passwordHasErrors={passwordHasErrors}
          roomNameHasErrors={roomNameHasErrors}
        />
      )
    case EDIT_PERSONAL_ROOM_SCREENS.EDIT_SUCCESS:
      return (
        <EditSuccessScreen
          personalRoom={personalRoom}
          url={url}
        />
      )
    case EDIT_PERSONAL_ROOM_SCREENS.CONFIRM_UPDATE_PASSWORD:
      return (
        <ConfirmUpdatePasswordScreen
          addPassword={updatePassword}
        />
      )
    case EDIT_PERSONAL_ROOM_SCREENS.COPY_NEW_INFO:
      return (
        <CopyNewInfoScreen copyInfo={copy} />
      )
    default:
      hideDialog()
  }

  return null
}

const mapStateToProps = state => ({
  password: getPersonalRoomPassword(state),
  personalRoom: getPersonalRoomName(state),
  url: getPersonalRoomUrl(state)
})

const mapDispatchToProps = {
  copyPersonalRoomInfo,
  updatePersonalRoomName,
  updatePersonalRoomPassword,
  deletePersonalRoomPassword
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalRoomDialogs)
